/* eslint-disable no-console */
const TOPWEB_CONFIG = {
  companyName: 'TOP WEB TELECOM',
  slogan: 'Conectando você ao futuro',
  primaryColor: '#FF6B35',
  secondaryColor: '#1A1A1A',
  supportPhone: '(11) 99999-9999',
  supportEmail: 'suporte@topwebtelecom.com.br',
  website: 'https://topwebtelecom.com.br',
};

const headerSelectors = [
  '.header',
  '.app-header',
  '.primary-nav',
  '.woot-header',
];
const sidebarSelectors = [
  '.sidebar',
  '.sidenav',
  '.app-sidebar',
  '.woot-sidebar',
];

const createElementFromHTML = htmlString => {
  const template = document.createElement('template');
  template.innerHTML = htmlString.trim();
  return template.content.firstElementChild;
};

const ensureHeaderBranding = () => {
  headerSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(header => {
      if (header.querySelector('.topweb-brand')) {
        return;
      }

      const brand = createElementFromHTML(`
        <div class="topweb-brand flex items-center gap-3 px-3 py-2">
          <div class="rounded-lg bg-white text-[#FF6B35] font-bold text-sm flex items-center justify-center" style="width: 36px; height: 36px;">
            TWB
          </div>
          <div class="text-white text-xs">
            <div class="font-semibold text-sm">${TOPWEB_CONFIG.companyName}</div>
            <div>${TOPWEB_CONFIG.slogan}</div>
          </div>
        </div>
      `);

      header.appendChild(brand);
    });
  });

  document.title = `${TOPWEB_CONFIG.companyName} - Atendimento`;
};

const ensureSidebarCard = () => {
  sidebarSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(sidebar => {
      if (sidebar.querySelector('.topweb-contact-card')) {
        return;
      }

      const card = createElementFromHTML(`
        <div class="topweb-contact-card mx-4 my-3 rounded-lg border border-[#FF6B35]/40 bg-[#FF6B35]/10 p-4 text-xs text-[#1A1A1A]">
          <div class="font-semibold text-sm text-[#FF6B35] mb-2">Contato TOP WEB</div>
          <div class="text-gray-700">📞 ${TOPWEB_CONFIG.supportPhone}</div>
          <div class="text-gray-700">✉️ ${TOPWEB_CONFIG.supportEmail}</div>
          <div class="text-gray-700">🌐 ${TOPWEB_CONFIG.website}</div>
        </div>
      `);

      sidebar.appendChild(card);
    });
  });
};

const ensureStatusWidget = () => {
  if (document.querySelector('#topweb-status-widget')) {
    return;
  }

  const widget = createElementFromHTML(`
    <div id="topweb-status-widget" class="fixed top-5 right-5 z-40 rounded-xl border-2 border-[#FF6B35]/30 bg-white/95 p-4 shadow-2xl">
      <div class="flex items-center gap-2 mb-2">
        <span class="h-3 w-3 rounded-full bg-green-500 animate-pulse"></span>
        <strong class="text-[#FF6B35] text-sm">Status dos Serviços</strong>
      </div>
      <ul class="text-xs text-gray-600 space-y-1">
        <li>✅ Internet: Operacional</li>
        <li>✅ Telefonia: Operacional</li>
        <li>✅ Suporte: Online</li>
      </ul>
      <div class="mt-2 text-[10px] text-gray-400">Atualizado às ${new Date().toLocaleTimeString('pt-BR')}</div>
    </div>
  `);

  document.body.appendChild(widget);
};

const getDashboardContainer = () =>
  document.querySelector('.dashboard-app--content') ||
  document.querySelector('.dashboard-app') ||
  document.querySelector('.home__body') ||
  document.querySelector('#app');

class TopWebKanban {
  constructor() {
    this.boards = [
      { id: 'backlog', title: 'Backlog', color: '#6c757d', tickets: [] },
      { id: 'todo', title: 'A Fazer', color: '#17a2b8', tickets: [] },
      {
        id: 'in-progress',
        title: 'Em Andamento',
        color: '#FF6B35',
        tickets: [],
      },
      { id: 'review', title: 'Em Revisão', color: '#ffc107', tickets: [] },
      { id: 'done', title: 'Concluído', color: '#28a745', tickets: [] },
    ];
    this.currentTicketId = 3;
    this.draggedTicket = null;
    this.priorityColors = {
      high: '#dc3545',
      medium: '#FF6B35',
      low: '#28a745',
    };

    this.loadSampleTickets();
    this.render();
  }

  loadSampleTickets() {
    this.boards[0].tickets.push({
      id: 'ticket-1',
      title: 'Instalação Fibra Óptica',
      description: 'Agendar instalação 100MB para João Silva',
      priority: 'high',
      assignee: 'Técnico Rafael',
      created: new Date().toLocaleDateString('pt-BR'),
    });

    this.boards[2].tickets.push({
      id: 'ticket-2',
      title: 'Suporte - Internet Lenta',
      description: 'Cliente Maria relatou oscilação de sinal',
      priority: 'medium',
      assignee: 'Suporte Ana',
      created: new Date().toLocaleDateString('pt-BR'),
    });

    this.boards[4].tickets.push({
      id: 'ticket-3',
      title: 'Upgrade Plano 200MB',
      description: 'Carlos confirmou upgrade concluído',
      priority: 'low',
      assignee: 'Vendas Pedro',
      created: new Date().toLocaleDateString('pt-BR'),
    });
  }

  createContainer() {
    const container = createElementFromHTML(`
      <section id="topweb-kanban" class="topweb-kanban">
        <div class="topweb-kanban__header">
          <h3 class="font-semibold text-white text-lg">
            📋 Kanban - ${TOPWEB_CONFIG.companyName}
          </h3>
          <div class="flex gap-2">
            <button class="rounded-md border border-white/30 bg-white/10 px-3 py-1 text-xs text-white" id="topweb-kanban-add">+ Novo Ticket</button>
            <button class="rounded-md border border-white/30 bg-white/10 px-3 py-1 text-xs text-white" id="topweb-kanban-settings">⚙️</button>
          </div>
        </div>
        <div id="topweb-kanban-boards" class="topweb-kanban__boards"></div>
      </section>
    `);

    const host = getDashboardContainer();
    if (host) {
      host.prepend(container);
    }

    this.boardsContainer = container.querySelector('#topweb-kanban-boards');

    container
      .querySelector('#topweb-kanban-add')
      .addEventListener('click', () => this.showTicketModal());
  }

  render() {
    if (!document.querySelector('#topweb-kanban')) {
      this.createContainer();
    }

    if (!this.boardsContainer) {
      return;
    }

    this.boardsContainer.innerHTML = this.boards
      .map(
        board => `
          <div class="topweb-kanban__board" data-board="${board.id}" style="border-top-color: ${board.color}">
            <div class="flex items-center justify-between mb-4">
              <h4 class="font-semibold text-sm" style="color:${board.color}">${board.title}</h4>
              <span class="rounded-full px-2 text-xs text-white" style="background:${board.color}">${board.tickets.length}</span>
            </div>
            <div class="topweb-kanban__tickets">
              ${board.tickets.map(ticket => this.renderTicket(ticket)).join('')}
            </div>
          </div>
        `
      )
      .join('');

    this.setupDragAndDrop();
  }

  renderTicket(ticket) {
    const priorityColor = this.priorityColors[ticket.priority];

    return `
      <div class="topweb-kanban__ticket" draggable="true" data-ticket="${ticket.id}" style="border-left-color:${priorityColor}">
        <div class="flex items-start justify-between mb-2">
          <h5 class="font-semibold text-sm text-[#1A1A1A]">${ticket.title}</h5>
          <span class="rounded px-2 text-[10px] font-semibold text-white" style="background:${priorityColor}">
            ${ticket.priority.toUpperCase()}
          </span>
        </div>
        <p class="text-xs text-gray-600 mb-3">${ticket.description}</p>
        <div class="flex items-center justify-between text-[11px] text-gray-500">
          <span>👤 ${ticket.assignee}</span>
          <span>📅 ${ticket.created}</span>
        </div>
      </div>
    `;
  }

  setupDragAndDrop() {
    const tickets = document.querySelectorAll('.topweb-kanban__ticket');
    const boards = document.querySelectorAll('.topweb-kanban__board');

    tickets.forEach(ticket => {
      ticket.addEventListener('dragstart', event => {
        this.draggedTicket = event.target.dataset.ticket;
        event.target.classList.add('opacity-75');
      });

      ticket.addEventListener('dragend', event => {
        event.target.classList.remove('opacity-75');
        this.draggedTicket = null;
      });
    });

    boards.forEach(board => {
      board.addEventListener('dragover', event => event.preventDefault());
      board.addEventListener('drop', () => {
        if (this.draggedTicket) {
          this.moveTicket(this.draggedTicket, board.dataset.board);
        }
      });
    });
  }

  moveTicket(ticketId, boardId) {
    let ticket;
    this.boards.forEach(board => {
      const index = board.tickets.findIndex(item => item.id === ticketId);
      if (index !== -1) {
        [ticket] = board.tickets.splice(index, 1);
      }
    });

    if (!ticket) {
      return;
    }

    const targetBoard = this.boards.find(item => item.id === boardId);
    targetBoard.tickets.push(ticket);
    this.render();
  }

  showTicketModal() {
    const modal = createElementFromHTML(`
      <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" id="topweb-kanban-modal">
        <div class="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
          <h3 class="mb-4 text-lg font-semibold text-[#FF6B35]">Novo Ticket</h3>
          <form class="space-y-4">
            <label class="block text-sm font-medium text-gray-700">
              Título
              <input type="text" name="title" class="mt-1 w-full rounded-md border border-gray-200 px-3 py-2" required />
            </label>
            <label class="block text-sm font-medium text-gray-700">
              Descrição
              <textarea name="description" class="mt-1 w-full rounded-md border border-gray-200 px-3 py-2" rows="3" required></textarea>
            </label>
            <div class="grid grid-cols-2 gap-4">
              <label class="block text-sm font-medium text-gray-700">
                Prioridade
                <select name="priority" class="mt-1 w-full rounded-md border border-gray-200 px-3 py-2">
                  <option value="low">Baixa</option>
                  <option value="medium" selected>Média</option>
                  <option value="high">Alta</option>
                </select>
              </label>
              <label class="block text-sm font-medium text-gray-700">
                Responsável
                <input type="text" name="assignee" class="mt-1 w-full rounded-md border border-gray-200 px-3 py-2" value="Equipe TOP WEB" />
              </label>
            </div>
            <div class="flex justify-end gap-3 pt-2">
              <button type="button" class="rounded-md border px-4 py-2 text-sm" id="topweb-modal-cancel">Cancelar</button>
              <button type="submit" class="rounded-md bg-[#FF6B35] px-4 py-2 text-sm text-white">Criar</button>
            </div>
          </form>
        </div>
      </div>
    `);

    document.body.appendChild(modal);

    modal.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const ticket = {
        id: `ticket-${Date.now()}`,
        title: formData.get('title'),
        description: formData.get('description'),
        priority: formData.get('priority'),
        assignee: formData.get('assignee'),
        created: new Date().toLocaleDateString('pt-BR'),
      };
      this.boards[0].tickets.push(ticket);
      this.render();
      modal.remove();
    });

    modal
      .querySelector('#topweb-modal-cancel')
      .addEventListener('click', () => modal.remove());
    modal.addEventListener('click', event => {
      if (event.target.id === 'topweb-kanban-modal') {
        modal.remove();
      }
    });
  }
}

let kanbanInstance;

export const initializeTopWebExperience = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const run = () => {
    ensureHeaderBranding();
    ensureSidebarCard();
    ensureStatusWidget();

    if (!kanbanInstance) {
      kanbanInstance = new TopWebKanban();
    } else {
      kanbanInstance.render();
    }
  };

  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    setTimeout(run, 500);
  } else {
    document.addEventListener('DOMContentLoaded', () => setTimeout(run, 500));
  }

  const observer = new MutationObserver(() => {
    setTimeout(() => {
      ensureHeaderBranding();
      ensureSidebarCard();
    }, 250);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.topwebConfig = TOPWEB_CONFIG;
  console.info('TOP WEB TELECOM theme initialized');
};
